import { useAchievementTypes, useReduxState } from 'hooks';
import { getMessageWithPlaceholders } from 'shared-locales';
import { breakpoints } from 'styles';
import { AchievementIcon } from 'components/achievements';
import {
  ContentLabel,
  FlexContainer,
  ProductLinkWithIcon
} from 'components/common';
import { CompetenciesProductBadge } from 'components/competencies';
import { Popover } from 'components/common/popover';

import type { GetCalendarEventAdditionalRenderingInfoRes } from 'shared-types/responses';

interface Props {
  achievement: GetCalendarEventAdditionalRenderingInfoRes['achievements'][0];
}

const CalendarEventRenderInfoAchievement = ({ achievement }: Props) => {
  const { messages, theme } = useReduxState();

  const achievementTypes = useAchievementTypes();

  return (
    <>
      <Popover
        content={
          <div className="content">
            <div className="header">
              <AchievementIcon size="small" type={achievement.type} />
              <div className="title-wrapper">
                <div className="type">
                  {achievementTypes[achievement.type].title}
                </div>
                <div className="title">{achievement.title}</div>
              </div>
            </div>

            {achievement.competencies?.length ? (
              <div className="info">
                <ContentLabel label={messages.competenciesGranted}>
                  <FlexContainer style={{ flexWrap: 'wrap', gap: 10 }}>
                    {achievement.competencies.map((competency) => (
                      <CompetenciesProductBadge
                        key={competency.id}
                        competency={competency}
                      />
                    ))}
                  </FlexContainer>
                </ContentLabel>
              </div>
            ) : null}
          </div>
        }
        key={achievement.id}
      >
        {(setIsOpen) => (
          <ProductLinkWithIcon
            achievement={achievement}
            key={achievement.id}
            disableLink={true}
            onClick={() => setIsOpen(true)}
          >
            {achievement.competencies?.length
              ? getMessageWithPlaceholders({
                  message: messages.competenciesGrantedNumberOf,
                  placeholders: {
                    numberOfCompetencies: achievement.competencies.length
                  }
                })
              : null}
          </ProductLinkWithIcon>
        )}
      </Popover>

      <style jsx>{`
        .content {
          min-width: 200px;
          max-width: 260px;
          padding: 5px 0;
        }
        .header {
          display: flex;
          gap: 10px;
        }
        .type {
          color: ${theme.textColorLight};
          font-size: 1.4rem;
          font-weight: 600;
        }
        .title {
          font-size: 1.6rem;
          font-weight: 700;
          display: -webkit-box;
          margin-top: 2px;
        }
        .info {
          margin-top: 20px;
        }
        @media (min-width: ${breakpoints.small}px) {
          .content {
            max-width: 360px;
          }
        }
      `}</style>
    </>
  );
};

export default CalendarEventRenderInfoAchievement;
